/* eslint-disable react/jsx-no-useless-fragment */
import { CSSProperties } from "react"

import {
  Link,
  LinkTag,
  WidgetTag,
  connect,
  isInPlaceEditingActive,
  provideComponent
} from "scrivito"
import { alignmentClassName } from "scrivito/Widgets/utils/alignmentClassName"
import { alternativeTextForObj } from "scrivito/Widgets/utils/alternativeTextForObj"
import { ScrivitoImage } from "scrivito/scrivito-image/ScrivitoImage"

import { LightDarkImageWidget } from "./LightDarkImageWidgetClass"
import "./_light-dark-image-widget.scss"

provideComponent(LightDarkImageWidget, ({ widget }) => {
  const classNames = ["image-widget", "light-dark-image-widget"]
  const alignment = alignmentClassName(widget.get("alignment"))
  if (alignment) classNames.push(alignment)

  let style: CSSProperties | undefined
  const height = widget.get("height")
  if (height) style = { ...style, height }
  const width = widget.get("width")
  if (width) style = { ...style, width }
  const objectFit = widget.get("objectFit")
  if (height && objectFit === "cover") style = { ...style, objectFit }

  const alternativeText =
    widget.get("alternativeText") ||
    alternativeTextForObj(widget.get("lightImage")) ||
    alternativeTextForObj(widget.get("darkImage"))

  const imageClassName = widget.get("roundCorners") ? "rounded" : undefined

  return (
    <WidgetTag className={classNames.join(" ")}>
      <LinkWrapper link={widget.get("link")}>
        <ScrivitoImage
          alt={alternativeText}
          className={`light-dark-image-widget__image light-dark-image-widget__image--light ${
            imageClassName || ""
          }`}
          attribute="lightImage"
          content={widget}
          style={style}
        />
        <ScrivitoImage
          alt={alternativeText}
          className={`light-dark-image-widget__image light-dark-image-widget__image--dark ${
            imageClassName || ""
          }`}
          attribute="darkImage"
          content={widget}
          style={style}
        />
      </LinkWrapper>
    </WidgetTag>
  )
})

const LinkWrapper = connect(
  ({ link, children }: { link: Link | null; children: React.ReactNode }) => {
    if (isInPlaceEditingActive()) return <>{children}</>
    if (!link) return <>{children}</>

    return <LinkTag to={link}>{children}</LinkTag>
  }
)
